import { db } from "@/firebaseConfig";

const scheduleByMenuCollection = db.collection("schedule_by_menu");

const saveScheduleByMenu = async (id, data) => {
  scheduleByMenuCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("ScheduleByMenu successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateScheduleByMenu = async (id, data) => {
  scheduleByMenuCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("ScheduleByMenu successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteScheduleByMenu = async id => {
  scheduleByMenuCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("ScheduleByMenu successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getScheduleByMenuById = async id => {
  return scheduleByMenuCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  scheduleByMenuCollection,
  saveScheduleByMenu,
  updateScheduleByMenu,
  deleteScheduleByMenu,
  getScheduleByMenuById
};
